<template>
    <div class="step-bar-container">
        <Step
            :state="isActive(0)"
            :number="1"
            :title="$t('outils.compteur.bar.partenaire')"
            :subtitle="site?.description ?? ''"
        />
        <div class="separator"></div>
        <Step
            :state="isActive(1)"
            :number="2"
            :title="$t('outils.compteur.bar.representant')"
            :subtitle="type?.libelle ?? ''"
        />
        <div class="separator"></div>
        <Step
            :state="isActive(2)"
            :number="3"
            :title="$t('outils.compteur.bar.compteurs')"
            :subtitle="equipement"
        />
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Step, { StepState } from '../../../components/ui-components/Step.vue';
import { TypeItems } from '@/models/TypeItems';
import { Site } from '@/models/Site';

export default defineComponent({
    components: {
        Step,
    },
    setup() {
        return {
            StepState,
        };
    },
    props: {
        step: { type: Number, required: true },
    },
    methods: {
        isActive(n: number) {
            if (n < this.step) {
                return StepState.valid;
            } else {
                return n === this.step ? StepState.active : StepState.inactive;
            }
        },
    },
    computed: {
        site(): Site | undefined {
            return this.$store.getters.getInterventionSiteValue;
        },
        type(): TypeItems | undefined {
            return this.$store.getters.getInterventionTypeValue;
        },
        equipement(): string {
            return this.$store.getters.getInterventionEquipementValue?.libelle ?? '';
        },
        objet(): string {
            return this.$store.getters.getInterventionObjetValue;
        }
    },
});
</script>

<style scoped>
.step-bar-container {
    display: flex;
    justify-content: space-between;
    width: calc(100% - 48px);
    background-color: #fff;
    height: 28px;
    align-items: center;
    padding: 16px 24px;
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14), 0 1px 5px rgba(0, 0, 0, 0.12);
    border-radius: 6px;
}
.separator {
    height: 1px;
    background-color: var(--medium-light-grey);
    flex-shrink: 1;
    min-width: 21px;
}
</style>
